module.exports = __webpack_public_path__ + "img/img.31df788d.png";